import React from 'react';
import { useSearchParams } from 'react-router-dom';

const GamePlay = () => {
  const [searchParams] = useSearchParams();
  const url = searchParams.get('url');

  return (
    <div style={{ background: '#f7f7f7', minHeight: '100vh', padding: '20px' }}>
    
      {url ? (
        <iframe
          src={url}
          width="100%"
         
          style={{
            border: "4px solid #000",
            borderRadius: "15px",
             minHeight:"calc(100vh - 100px)"
          }}
          title="game-frame"
          allowFullScreen
        />
      ) : (
        <p style={{ textAlign: 'center' }}>No game URL provided</p>
      )}
    </div>
  );
};

export default GamePlay;
